import baseUrl from "../../../utils/api";
import noCover from '@/assets/images/no-cover.png';
import Vue from 'vue'

export default {
  name: "classBuy",
  data() {
    return {
      noCover,
      id: this.$route.query.id,
      list: {},
      school: {},

      videoData: {
        show: false,
        title: '',
        src: ''
      },

      offline_num: 1, // 线下课次数
      online_num: 1, // 线上课次数

      online_min: 0,
      offline_min: 0,

      price_all: 0, // 原总价
      price_discount: 0, // 优惠总价

      dialogCheck: { // 支付确认 - 未支付
        loading: false,
        data: {
          recharge: {}
        },
        watch: null, // 监听支付结果
        show: false
      },
      successDialog: false, // 支付确认 - 支付成功

      maxLine: 999999,
      online_old: 0,
      offline_old: 0
    }
  },
  created () {
    const _id = localStorage.getItem('school_id') || this.choicesSchool.id;

    this.$store.state.school.forEach(val => {
      val.id == _id && (this.school = val);
    });

    const _item = sessionStorage.getItem('classDetailList');

    if (_item) {
      this.list = JSON.parse(_item);

      this.offline_min = this.list.min_offline_num || 0;
      this.online_min = this.list.min_online_num || 0;

      this.offline_num = this.list.min_offline_num;
      this.online_num = this.list.min_online_num || 0;

      if (!this.offline_num) {
        this.offline_num = this.online_num ? 0 : 1;
      }

      this.countPrice();
    } else {
      this.$router.push('/goods');
    }
  },
  methods: {
    // 视频 - 显示
    showVideo (name, src) {
      this.videoData.title = name;
      this.videoData.src = src;
      this.videoData.show = true;
    },

    // 视频 - 播放
    videoOpen () {
      this.$refs.ref_video.play();
    },

    // 视频 - 关闭
    videoClose () {
      this.$refs.ref_video.pause();
    },

    // 原总价 | 优惠总价
    countPrice (line) {
      if (line) {
        let _n = this[`${line}line_num`];

        if (!_n) {
          _n = 0;
        }

        let _m = parseInt(_n);

        if (isNaN(_m)) {
          _m = this[`${line}line_old`];
        }

        if (_m > this.maxLine) {
          _m = this.maxLine;
        } else if (_m < this[`${line}line_min`]) {
          _m = this[`${line}line_min`];
        }

        !_m && this.online_num < 1 && this.offline_num < 1 && (_m = 1);

        this[`${line}line_num`] = _m;
      }

      this.online_old = this.online_num;
      this.offline_old = this.offline_num;

      this.price_all = this.list.offline_price * this.offline_num + this.list.online_price * this.online_num;
      this.price_discount = (1e4 * this.list.offline_discount_price * this.offline_num + 1e4 * this.list.online_discount_price * this.online_num) / 1e4;
    },

    countPlus (line) {
      this[`${line}line_num`] ++;

      this.countPrice(line);
    },

    countMinus (line) {
      this[`${line}line_num`] --;

      this.countPrice(line);
    },

    // 课程 - 购买
    classBuy () {
      this.dialogCheck.loading = true;

      this.$http.post(`${baseUrl}/api/course/commodities/orders`, {
        commodities_id: this.id,
        offline_num: this.offline_num,
        online_num: this.online_num,
        school_id: this.school.id
      }).then(res => {
        const _data = res.data;

        this.$http.patch(`${this.$checkHttp() + this.school.domain}/api/course/commodities/orders/${_data.id}`, {
          status: 2,
        }).then(res => {
          const _data2 = res.data;

          if (_data2.status == 1) {
            // 未支付
            this.dialogCheck.data = _data2;
            this.dialogCheck.show = true;

            this.dialogCheck.watch = setInterval(() => {
              this.watchBuy(_data2.recharge.out_trade_no)
            }, 2e3);
          } else if (_data2.status == 2) {
            // 已支付
            this.successDialog = true;
          }
        })
        .catch(res => this.$message.error(res.message))
        .finally(() => this.dialogCheck.loading = false)
      }).catch(res => {
        this.$message.error(/400/.test(res.message) ? '该商品已下架！请返回课程商品' : res.message);
        this.dialogCheck.loading = false;
      })
    },

    // 监听支付结果
    watchBuy (out_trade_no) {
      this.$http.get(`${baseUrl}/api/expense/main/${this.school.main_id}/recharge-query/${out_trade_no}`)
        .then((res) => {
          if (res.data.trade_status === 'success') {
            this.dialogCheck.show = false;
            this.successDialog = true;
          }
        }).catch(res => {
          console.log(res);
        // this.watchClear();
        // this.$message.error('请求异常! 可在"我的课程"查看结果');
      })
    },

    // 清楚监听
    watchClear () {
      if (this.dialogCheck.watch) {
        clearInterval(this.dialogCheck.watch);
        this.dialogCheck.watch = null;
      }
    },

    // 确认并跳转我的课程
    routerMyClass () {
      if (typeof window.JumpToMyClass !== 'undefined') {
        this.$router.go(-2);
        window.JumpToMyClass();
      } else {
        this.$router.push({
          path: '/myClass',
          query: {
            page: 1,
            per_page: 10
          },
        });
      }
    },

    // 去支付
    getCover () {
      window.open(this.dialogCheck.data.recharge.code_img_url);
    },
  },

  computed: {
    choicesSchool() {
      return this.$store.state.choicesSchool;
    }
  },

  beforeDestroy () {
    this.watchClear();
  }
}



// WEBPACK FOOTER //
// ./src/views/Goods/ClassBuy/index.js